// Table cols for Assemblies and Parts Table
export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  isDetailed: true,
  stickeyHeaders: true,
  detailRowComponent: 'mf-detail-row',
  isCheckable: false,
  gutterOpts: {},
  isCardView: true,
  toolBar: {
    buttons: () => {
      const buttons = [{
        event: 'showArchive',
        icon: 'icon-addnew',
        tooltip: 'Add New',
        isLine: true,
        type: 'switch',
        label: 'Show Archived Only'
      }, {
        event: 'addParts',
        icon: 'icon-addnew',
        tooltip: 'Add New',
        isLine: true,
        permissionModule: 'app&projects',
        permissionType: 'assemblyParts',
      },
      {
        event: 'excelImport',
        icon: 'icon-importexcel',
        tooltip: 'Import From Excel',
        isLine: true,
        permissionModule: 'app&projects',
        permissionType: 'assemblyParts',
      }];
      return buttons;
    },
    bulkActions: () => {
      const opts = [{
        name: 'Delete Parts',
        event: 'multiDelete',
        label: 'Delete Parts',
      }, {
        name: 'Archive Parts',
        event: 'multiArchive',
        label: 'Archive Parts',
      }];
      return opts;
    },
  },
  fields: [
    {
      name: 'field-generic-input',
      width: '400px',
      title: 'Name',
      sticky: true,
      bulkActionButtonField: true,
      searchable: true,
      id: 'name',
      sortField: 'name',
      defaultVisible: true,
      prop: 'name',
    },
    {
      title: 'Catalog',
      name: 'projectName',
      width: '400px',
      id: 'catalogProjects',
      prop: 'projectName[0].name',
      searchable: true,
      defaultVisible: true,
      filterText: 'Company/Project Catalogs'
    },
    {
      name: 'field-cat-id',
      width: '152px',
      title: 'Catalog ID',
      sortField: 'catId',
      id: 'catId',
      prop: 'catId',
      allowAutoComplete: true,
      verifyCatId: true,
      defaultVisible: true,
      inputProps: {
        type: 'text',
        disableEdit: true,
      },
    },
    {
      title: 'Part ID',
      name: 'field-generic-input',
      width: '112px',
      id: 'customId',
      defaultVisible: true,
      prop: 'customId',
      sortField: 'customId',
      inputProps: {
        type: 'text',
      },
    },
    {
      name: 'categorySelect',
      width: '192px',
      title: 'Category',
      id: 'category',
      prop: 'category.name',
      defaultVisible: true,
      searchable: true,
      filterText: 'Categories',
    },
    {
      name: 'subCategorySelect',
      width: '192px',
      title: 'Sub-Category',
      id: 'subCategory',
      prop: 'subCategory.name',
      defaultVisible: true,
      searchable: true,
      filterText: 'Sub-Categories',
    },
    {
      name: 'field-generic-input',
      width: '296px',
      title: 'Description',
      id: 'desc',
      defaultVisible: true,
      prop: 'desc',
    },
    // {
    //   name: 'measureUnits',
    //   width: '152px',
    //   title: 'Measure Units',
    //   id: 'measureUnits',
    //   sortField: 'measureUnits',
    //   defaultVisible: true,
    // },
    {
      name: 'field-generic-input',
      width: '112px',
      title: 'Purchase',
      id: 'purchase',
      defaultVisible: true,
      type: 'checkbox',
      prop: 'purchase',
    },
    {
      title: 'Actions',
      name: 'table-field-actions',
      id: 'action',
      hideFromChooser: true,
      alwaysVisible: false,
      defaultVisible: true,
      width: '112px',
      sticky: true,
      clearBtn: true,
      searchable: true,
      hideAllFilters: false,
      permissionModule: 'app&projects',
      permissionKey: 'assembly_parts',
      thAttrs: () => ({ class: 'action-sticky' }),
      tdClass: 'action-sticky',
      inputProps: {
        showEdit: true,
        options(catalog) {
          const opts = [{
            icon: 'icon-activityhistory',
            label: 'Delete',
            event: 'catalogDelete',
            permissionModule: 'app&projects',
            permissionType: 'assemblyParts',
            isDisabled() {
              return catalog.partOf > 0;
            },
          }];
          if (catalog.isTemporaryDelete) {
            opts.push({
              icon: 'icon-activityhistory',
              label: 'Restore',
              event: 'catalogUnArchive',
              permissionModule: 'app&projects',
              permissionType: 'assemblyParts',
            });
          } else {
            opts.unshift({
              icon: 'icon-bin',
              label: 'Archive',
              event: 'catalogArchive',
              isDisabled() {
                return catalog.partOf > 0;
              },
              permissionModule: 'app&projects',
              permissionType: 'assemblyParts',
            });
          }
          return opts;
        },
      },
    },
  ],
};
